import { render, staticRenderFns } from "./ShipmentNoteNew.vue?vue&type=template&id=4405908a&scoped=true"
import script from "./ShipmentNoteNew.vue?vue&type=script&lang=js"
export * from "./ShipmentNoteNew.vue?vue&type=script&lang=js"
import style0 from "./ShipmentNoteNew.vue?vue&type=style&index=0&id=4405908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405908a",
  null
  
)

export default component.exports